import React from "react";
import {
  InputNumber,
  Tooltip,
  Typography,
  Flex,
  Input,
  Select,
  Checkbox,
} from "antd";
import refreshIcon from "../../../assets/images/refreshIcon.svg";
import SetupSensorIcon from "../../../assets/images/SetupSensorIcon.jsx";
import SensorInfoIcon from "../../../assets/images/SensorInfoIcon.jsx";
import SensorInfoIconDisabled from "../../../assets/images/SensorInfoIconDisabled.jsx";
const { Text } = Typography;
const ShipmentAlertThresholdInput = ({
  setupSensorRuleIds,
  teamsOptions,
  isChecked,
  onCheckboxChange,
  shipment,
  allTeamThresholds,
  thresholds,
  rule,
  value,
  onChange,
  defaultThresholds,
  navigate,
  setupSensor,
  selectedTeam,
  disabled,
}) => {
  console.log(shipment, "shipemtn is");
  const goDefault = selectedTeam?.length === 0 || selectedTeam === "all";
  const compareAgainst = goDefault ? defaultThresholds : allTeamThresholds;
  const showResetIcon =
    rule.showResetIcon && thresholds?.[rule.id] !== compareAgainst?.[rule.id];
  const shouldDisableReset =
    selectedTeam?.length === 0 && teamsOptions.length !== 0;

  const isSensorDependentRule =
    setupSensorRuleIds.includes(rule.id) ||
    rule.showSensorInfoIconDisabled ||
    rule.showSetupSensorIcon;

  const isFieldDisabled =
    disabled ||
    (isSensorDependentRule && shipment?.sensor === null) ||
    rule.defaultValue === "NA";

  return (
    <Flex
      align="center"
      justify="flex-start"
      style={{
        gap: 24,
        margin: "10px 0px",
        // padding: "12px 0",
        backgroundColor: isChecked ? "#EFF4FE" : "transparent",
        borderRadius: 8,
      }}
    >
      <Checkbox
        disabled={isFieldDisabled}
        checked={isChecked}
        onChange={(e) => onCheckboxChange(e.target.checked)}
        style={{ margin: 0 }}
      />

      <Flex vertical style={{ paddingRight: 20, flex: 1, minWidth: 0 }}>
        <Flex align="center" gap={4} style={{ marginBottom: 4 }}>
          <Text style={{ fontSize: 14, lineHeight: "20px", fontWeight: "600" }}>
            {rule.title}
          </Text>

          {setupSensorRuleIds.includes(rule.id) ? (
            <Tooltip title="Sensor required: The correct sensor must be connected to enable this alert">
              {shipment?.sensor === null ? (
                <SensorInfoIconDisabled className="svg-icon gray-icon hover-yellow" />
              ) : (
                <SensorInfoIcon className="svg-icon gray-icon hover-blue" />
              )}
            </Tooltip>
          ) : (
            <>
              {rule.showSensorInfoIcon && (
                <Tooltip title="Sensor enabled">
                  <SensorInfoIcon className="svg-icon gray-icon hover-blue" />
                </Tooltip>
              )}
              {rule.showSensorInfoIconDisabled && (
                <Tooltip title="Sensor required: The correct sensor must be connected to enable this alert">
                  <SensorInfoIconDisabled className="svg-icon gray-icon hover-yellow" />
                </Tooltip>
              )}
              {rule.showSetupSensorIcon && (
                <Tooltip title="Critical alert: An alert that is indicative of a potential product compromise">
                  <SetupSensorIcon className="svg-icon gray-icon hover-red" />
                </Tooltip>
              )}
            </>
          )}

          {rule.sensorNote && (
            <Text
              className="dotted-border-spaced"
              style={{
                fontSize: 12,
                color: "black",
              }}
            >
              {rule.sensorNote}
            </Text>
          )}
        </Flex>

        <Text
          type="secondary"
          style={{ fontSize: 12, color: "#5E5E5E", lineHeight: "18px" }}
        >
          {rule.description}
        </Text>
      </Flex>
      <Flex align="center" gap={8}></Flex>
    </Flex>
  );
};
export default ShipmentAlertThresholdInput;
